import { render, staticRenderFns } from "./PartBulkEdit.vue?vue&type=template&id=4db970ae"
import script from "./PartBulkEdit.vue?vue&type=script&lang=js"
export * from "./PartBulkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports